import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
// First-party proxy (nginx /fx-events/ -> us.i.posthog.com) so Brave Shields / ad blockers
// don't drop the request. See infra/nginx/sites-enabled/foxet.
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://foxet.ai/fx-events';

if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',
    autocapture: true,
    capture_pageview: false, // manual via ScrollHandler
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
  });
}

export { posthog };
